import * as React from 'react';
import cn from 'classnames';
import './Group.css';

export type GroupProps = React.HTMLAttributes<HTMLElement> & {
    /**
     * Change what html tag element will render.
     * Default value is `span`
     */
    as?: 'div' | 'span' | 'nav';
    /** Content should be composed of other Taco elements */
    children: React.ReactNode;
};

export const Group = React.forwardRef(function Group(props: GroupProps, ref: React.Ref<HTMLDivElement>) {
    const { as: Tag = 'span', ...otherProps } = props;
    const className = cn('yt-group', props.className);
    return <Tag {...otherProps} className={className} ref={ref} />;
});
